import { connect } from 'react-redux';
import { makePath } from 'helpers/link-generation';
import { MANAGE_SERVICES_TAB } from 'constants/logic';
import { selectActiveVenueId, selectRouteParams } from 'selectors/general';
import messages from '../../ManageServices.messages';
import ListLink from './ListLink';

const mapStateToProps = state => {
  const venueId = selectActiveVenueId(state);
  const { tab } = selectRouteParams(state);
  let message;

  if (tab === MANAGE_SERVICES_TAB.PRACTITIONERS) {
    message = messages.practitioners;
  } else if (tab === MANAGE_SERVICES_TAB.RESOURCES) {
    message = messages.resources;
  } else if (tab === MANAGE_SERVICES_TAB.SERVICES) {
    message = messages.services;
  }

  return { backUrl: makePath.manageServices({ venueId, tab }), message };
};

export default connect(mapStateToProps)(ListLink);
